const resources = {
    lead: 'Sign in for *FREE standard shipping* on all orders.',
    signIn: 'Sign In',
    createAccount: 'Create Account',
    joinOurLoyaltyProgram: 'Join our FREE loyalty & rewards program',
    getFreeShipping: '🚚 Get FREE shipping on all orders',
    getFreeBirthdayGift: '🎂 FREE Birthday Gift when you spend $25+',
    earnOnePointPerSpent: '👛 Earn 1 point per $1 spent',
    biLogoAltText: 'Beauty Insider'
};

export default function getResource(label) {
    return resources[label];
}
